import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import axios from 'cccisd-axios';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import { useParams } from 'cccisd-react-router';
import query from './progress.graphql';
import { getSessionChecklistParentDeploymentId } from '../../helpers/helpers.js';

const Boilerplate = window.cccisd.boilerplate;

const TfhSessionChecklist = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [initialSessionNumber, setInitialSessionNumber] = useState(null);
    /* If all children are complete, this will be the parent ID to let te backend
        create the next Child. Otherwise, we force create a new Child. */
    const [deploymentId, setDeploymentId] = useState(null);
    const [metricspawn, setMetricspawn] = useState({});
    const params = useParams();

    useEffect(() => {
        async function getData() {
            const parentId = await getSessionChecklistParentDeploymentId();
            const resp = await client.query({
                query,
                variables: {
                    parentDeploymentId: parentId,
                    metricsPawnRespondentHash: params.respondentHash,
                },
                fetchPolicy: 'network-only',
            });

            let isAllChildrenComplete = true;
            const maxSessionNum = (_get(resp, 'data.roles.metricspawn.assignmentProgressList', []) || []).reduce(
                (max, currAp) => {
                    if (!currAp.completedDate) {
                        isAllChildrenComplete = false;
                    }

                    const currSessionNum = parseInt(currAp?.devTags?.sessionChecklistSessionNumber, 10);
                    if (!Number.isNaN(currSessionNum) && currSessionNum > max) {
                        return currSessionNum;
                    }

                    return max;
                },
                0
            );

            const pawn = _get(resp, 'data.roles.metricspawn.pawn', {}) || {};
            setMetricspawn(pawn);

            if (!pawn.pawnId || !pawn.pawnHash) {
                // error will show in render
                setIsLoading(false);
                setDeploymentId(-1);
                return;
            }

            if (isAllChildrenComplete) {
                // backend will do it's thing to create next one
                setDeploymentId(parentId);
            } else {
                // We need to manually make sure it moves on to the next one
                const next = await axios.get(
                    Boilerplate.route('api.assignmentDeployment.repeated', {
                        deploymentId: parentId,
                        pawnId: pawn.pawnId,
                        hash: params.respondentHash,
                    }),
                    { params: { forceRepeat: true } }
                );

                setDeploymentId(_get(next, 'data.data.deploymentId', -1));
            }

            setInitialSessionNumber(maxSessionNum + 1);
            setIsLoading(false);
        }

        getData();
    }, []);

    if (isLoading || !deploymentId) {
        return <Loader loading />;
    }

    if (!metricspawn.pawnId || !metricspawn.pawnHash) {
        return <div className="alert alert-warning">Incorrect link.</div>;
    }

    return (
        <DeploymentPlayer
            deploymentId={deploymentId}
            pawnId={metricspawn.pawnId}
            pawnHash={metricspawn.pawnHash}
            flowProps={{
                defaultValueVariables: {
                    sessionChecklistInitialSessionNumber: [initialSessionNumber],
                },
                variables: {
                    sessionChecklistLinkToProgress: Boilerplate.url(
                        `/dashboard?initialTab=progress&familyId=${metricspawn.pawnId}`
                    ),
                },
            }}
        />
    );
};

export default TfhSessionChecklist;
